import { render, staticRenderFns } from "./EmployeeClassification.vue?vue&type=template&id=28700a95&"
import script from "./EmployeeClassification.vue?vue&type=script&lang=js&"
export * from "./EmployeeClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports